import { render, staticRenderFns } from "./ProposalNetworksFaqView.vue?vue&type=template&id=7a8abbc4&"
import script from "./ProposalNetworksFaqView.vue?vue&type=script&lang=js&"
export * from "./ProposalNetworksFaqView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports